import Product from '@common/models/Product';
import {
  addProductToCart,
  CartSliceType,
  removeProductFromCart,
  subtractProductFromCart,
} from '@common/store/cart/slice';
import { RecentlyViewedTime } from '@common/store/recentlyViewed/slice';
import { StoreInfoSliceType } from '@common/store/storeInfo/slice';
// import { isMobile } from '@common/utils';
import ProductCard from '@components/ProductCard';
import Arrow from '@images/RightArrow.svg';
// import Rupee from '@instamojo/rupee';
import Link from '@lib/Link';
import classnames from 'classnames';
import React, { useState } from 'react';

interface RecentlyViewedProps {
  products: Record<number, Product & RecentlyViewedTime>;
  ignoreProducts?: Set<number>;
  cart: CartSliceType;
  addProductToCart: typeof addProductToCart;
  subtractProductFromCart: typeof subtractProductFromCart;
  removeProductFromCart: typeof removeProductFromCart;
  storeInfo: StoreInfoSliceType;
}

const RecentlyViewed: React.FunctionComponent<RecentlyViewedProps> = ({ products, ignoreProducts = new Set() }) => {
  const filteredProducts = Object.values(products)
    .reverse()
    .filter((product) => !ignoreProducts.has(product.id));

  const [LeftArrow, SetLeftArrow] = useState(false);
  const [RightArrow, SetRightArrow] = useState(true);

  if (!filteredProducts.length) {
    return null;
  }

  return (
    <div className="pl-10 md:pl-0 container px-0 relative">
      <div
        className="flex justify-center items-center text-black text-20 md:text-24 mt-20 font-bold leading-28 mb-20 md:mb-50"
        font-customisation="section-heading"
        color-customisation="page-heading"
      >
        Recently Viewed
      </div>
      {/* <div className="flex flex-row flex-no-wrap overflow-x-auto hideScroll">
          {filteredProducts.map((product) => (
            <Link key={product.id} to={product.storeLink} className="flex mr-10 md:mr-16">
              <div className="flex flex-col">
                <div className={'flex min-w-220 max-w-220 md:min-w-260 md:max-w-260 justify-center mb-6'}>
                  <img
                    src={product.images[0]}
                    alt={product.title}
                    className={classnames('w-full h-220 md:h-260 object-contain rounded')}
                  />
                </div>
                <div className="flex flex-col w-220 md:w-260">
                  <div className="flex font-bold text-14 md:text-16 text-black_variant_1 text-left mt-22 md:mt-26">
                    <p className="w-220 md:w-260 truncate ...">{product.title}</p>
                  </div>
                  <div className="flex justify-left items-center mt-14">
                    <div className="flex text-black_variant_1 text-18 md:text-20 mr-10 font-bold">
                      <Rupee value={product.finalPrice} />
                    </div>
                    {product.hasDiscount ? (
                      <div className="flex line-through font-medium text-18 md:text-20 text-disabledtext">
                        <Rupee value={product.price} />
                      </div>
                    ) : (
                      <div className="font-normal text-12">&nbsp;</div>
                    )}
                  </div>
                </div>
              </div>
            </Link>
            // </div>
          ))}
        </div> */}
      <div
        className={classnames('flex flex-row flex-no-wrap overflow-x-auto hideScroll md:mx-52 gap-16 md:gap-24')}
        id="RecentlyViewed"
        onScroll={() => {
          const ele = document.getElementById('RecentlyViewed');
          if (ele.scrollLeft > 50) SetLeftArrow(true);
          else SetLeftArrow(false);
          if (ele.scrollWidth - ele.scrollLeft === ele.clientWidth) SetRightArrow(false);
          else SetRightArrow(true);
        }}
      >
        {filteredProducts.map((product) => (
          <div className="first:ml-0 justify-start items-center" key={product.id}>
            <Link key={product.id} to={product.storeLink} className="flex">
              <ProductCard
                product={product}
                addProductToCart={addProductToCart}
                subtractProductFromCart={subtractProductFromCart}
                hideQuickView
                // cartProductQuantity={cart.quantityByProductId[product.id] || 0}
                // addToast={addToast}
                // storeInfo={storeInfo}
              />
            </Link>
          </div>
        ))}
      </div>
      {filteredProducts.length > 3 && (
        <div className="">
          {LeftArrow && (
            <div className="absolute left-0 top-0 h-full mt-20 flex items-center pointer-events-none">
              <button
                className=" h-fit focus:outline-none text-carouselArrow-enabled pointer-events-auto"
                onClick={() => {
                  document.getElementById('RecentlyViewed').scrollBy({
                    top: 0,
                    left: -600,
                    behavior: 'smooth',
                  });
                }}
              >
                <img
                  src={Arrow}
                  className="rounded-lg rounded-l-lg md:h-80 opacity-80 h-50 bg-white md:py-30 py-18 md:px-18 px-10 shadow-carouselArrow transform rotate-180"
                />
              </button>
            </div>
          )}
          {RightArrow && (
            <div className="absolute right-0 top-0 h-full flex items-center mt-20 pointer-events-none">
              <button
                className="h-fit focus:outline-none text-carouselArrow-enabled pointer-events-auto"
                onClick={() => {
                  document.getElementById('RecentlyViewed').scrollBy({
                    top: 0,
                    left: +600,
                    behavior: 'smooth',
                  });
                }}
              >
                <img
                  src={Arrow}
                  className=" rounded-lg md:h-80 h-50 opacity-80 bg-white md:py-30 py-18 md:px-18 px-10 shadow-carouselArrow"
                />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RecentlyViewed;
